import { NylasInitiateAuthRequestContent, NylasInitiateAuthResponseContent } from "@equaliq/api-model-v2";
import { createApiRequest } from "../common";

/**
 * API function to initiate OAuth flow to connect a Nylas account
 * @param request Optional provider hint
 * @returns Promise with OAuth authorization URL and state
 */
export const initiateIntegrationAuthApi = async (request: NylasInitiateAuthRequestContent = {}): Promise<NylasInitiateAuthResponseContent> => {
  const apiRequest = createApiRequest<NylasInitiateAuthResponseContent>('post', '/integrations/nylas/auth/initiate');
  return apiRequest(request);
};
